import { NewUserPopup } from 'views/new-user-popup';
import { OpsDeck } from './ops-deck';

/**
 * The Ops Deck carries its own header row (title, range presets, theme switch),
 * so the shared <Header/> is gone from this route — it was a second title bar
 * above the one the design draws.
 */
const DashboardPage = () => (
	<div className="dashboard-main-body">
		<OpsDeck />
		<NewUserPopup />
	</div>
);

export default DashboardPage;
